/**
 * Re-exports `getUsername` from @saviynt/common.
 *
 * This previously held a package-local copy. Now that @saviynt/common >=2.4.0
 * exposes `getUsername`, all packages share a single implementation with
 * Redux store + API fallback support (UI-1467).
 */
import { getUsername } from '@saviynt/common';

export default getUsername;
